var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6726 8.36794H18.0013V8.33335H10.5013V11.6667H15.2109C14.5238 13.6071 12.6776 15 10.5013 15C7.74005 15 5.5013 12.7613 5.5013 10C5.5013 7.23877 7.74005 5.00002 10.5013 5.00002C11.7759 5.00002 12.9355 5.48085 13.8184 6.26627L16.1755 3.90919C14.6871 2.5221 12.6963 1.66669 10.5013 1.66669C5.89922 1.66669 2.16797 5.39794 2.16797 10C2.16797 14.6021 5.89922 18.3334 10.5013 18.3334C15.1034 18.3334 18.8346 14.6021 18.8346 10C18.8346 9.44127 18.7771 8.89585 18.6726 8.36794Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 6.12127L5.86682 8.12919C6.60766 6.29502 8.40182 5.00002 10.5014 5.00002C11.776 5.00002 12.9356 5.48085 13.8185 6.26627L16.1756 3.90919C14.6872 2.5221 12.6964 1.66669 10.5014 1.66669C7.30057 1.66669 4.52474 3.47377 3.12891 6.12127Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5008 18.3333C12.6533 18.3333 14.6091 17.5096 16.0879 16.17L13.5087 13.9875C12.6439 14.6451 11.5872 15.0008 10.5008 15C8.33328 15 6.49286 13.6179 5.79953 11.6891L3.08203 13.7829C4.4612 16.4816 7.26203 18.3333 10.5008 18.3333Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6713 8.3679H18V8.33331H10.5V11.6666H15.2096C14.8809 12.5902 14.2889 13.3971 13.5067 13.9879L13.5079 13.9871L16.0871 16.1696C15.9046 16.3354 18.8333 14.1666 18.8333 9.99998C18.8333 9.44123 18.7758 8.89581 18.6713 8.3679Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ee7782736472eea1c9b04e8b2e2158bb.svg";
export { ForwardRef as ReactComponent };